import { jsx, jsxs } from "react/jsx-runtime";
import "react";
import { VisuallyHidden } from "@zillow/constellation";
import PropTypes from "prop-types";
const ChartDescription = ({
  name,
  xLabel,
  yLabel,
  xFormatter,
  yFormatter,
  dataPoints
}) => {
  const dataPointsToCommunicate = dataPoints.filter((point, index) => {
    if (index === 0) {
      return true;
    }
    if (point.info) {
      return true;
    }
    if (index === dataPoints.length - 1) {
      return true;
    }
    return false;
  });
  return /* @__PURE__ */ jsx(VisuallyHidden, { children: /* @__PURE__ */ jsxs("table", { "aria-label": name, children: [
    /* @__PURE__ */ jsx("thead", { children: /* @__PURE__ */ jsxs("tr", { children: [
      /* @__PURE__ */ jsx("th", { children: xLabel }),
      /* @__PURE__ */ jsx("th", { children: yLabel }),
      /* @__PURE__ */ jsx("th", { children: "Comments" })
    ] }) }),
    /* @__PURE__ */ jsx("tbody", { children: dataPointsToCommunicate.map(({
      x,
      y,
      info
    }) => /* @__PURE__ */ jsxs("tr", { children: [
      /* @__PURE__ */ jsx("td", { children: xFormatter ? xFormatter(x) : x }),
      /* @__PURE__ */ jsx("td", { children: yFormatter ? yFormatter(y) : y }),
      /* @__PURE__ */ jsx("td", { children: info })
    ] }, `${x},${y}`)) })
  ] }) });
};
ChartDescription.propTypes = {
  name: PropTypes.string.isRequired,
  xLabel: PropTypes.string.isRequired,
  yLabel: PropTypes.string.isRequired,
  xFormatter: PropTypes.func,
  yFormatter: PropTypes.func,
  dataPoints: PropTypes.arrayOf(PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    info: PropTypes.string
  }))
};
export {
  ChartDescription as default
};
